
export const preloadedValues = {
  cnPgRecStatus: false,
  cnPgDescricao: "",
  cnPgCriterioDiaUtil: 1,
};
